// extracted by mini-css-extract-plugin
module.exports = {"SetupForm":"EditAreaEffectForm_SetupForm__3Anem","FullRow":"EditAreaEffectForm_FullRow__d6CVy"};